interface SwitchToRegisterButtonProps {
  onSwitchToRegister: () => void
}

export const SwitchToRegisterButton = ({
  onSwitchToRegister,
}: SwitchToRegisterButtonProps) => {
  return (
    <button
      className="text-primary text-[14px] relative group"
      type="button"
      onClick={onSwitchToRegister}
    >
      <span>没有账号，去注册</span>
      <span className="absolute bottom-0 left-0 w-0 h-[1px] bg-gradient-to-r from-[#0059FF] to-[#8752FF] transition-all duration-300 group-hover:w-full"></span>
    </button>
  )
}
